import styled from 'styled-components';
import theme from 'src/theme';

export const Wrapper = styled.div`
    height: calc(100% - 60px);

    ul.reported-events-list {
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        max-height: 100%;
        padding: 0;
        li {
            display: flex;
            align-items: flex-start;
            margin: 0;
            cursor: pointer;
            padding: 0.15rem 0.15rem 0.15rem 0.35rem;

            &:hover {
                background: #eee;
            }

            &.alt-bg {
                background: #eff3f7;
            }

            &.is-selected {
                background: ${theme.legacyColors.selectedBackground};
                border: 1px solid #${theme.legacyColors.selectedBorder};
                color: ${theme.legacyColors.selectedColor};
                h5 {
                    color: ${theme.legacyColors.selectedColor};
                }
            }

            &.is-last-dependent {
                background: ${theme.legacyColors.dependencyBackground};
                border: 1px solid ${theme.legacyColors.dependencyBorder};
                color: ${theme.legacyColors.dependencyColor};
                h5 {
                    color: ${theme.legacyColors.dependencyColor};
                }
            }

            &.is-last-not-validating {
                background: ${theme.legacyColors.error};
                border: 1px solid ${theme.legacyColors.error};
                color: #fff;
                h5 {
                    color: #fff;
                }
            }

            .event-date {
                font-size: 0.8rem;
                margin-right: 10px;
                flex: 0 0 110px;
                //flex: 0 0 160px;
            }
            .event-display-name {
                font-weight: 500;
                font-size: 0.8rem;
                flex: 0 0 calc(100% - 150px);
                overflow: hidden;
                .ext-info {
                    display: block;
                    h5 {
                        display: inline-block;
                        margin-right: 3px;
                    }
                    .cargo-name {
                        font-weight: 400;
                        font-size: 0.7rem;
                        margin-right: 3px;
                        display: block;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        &::before {
                            content: '•';
                            padding: 0 5px 0 0;
                        }
                    }
                    .dropdown-item-name {
                        font-weight: 400;
                        font-size: 0.7rem;
                        margin-right: 3px;
                        display: block;
                        white-space: wrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        &::before {
                            // content: "•";
                            padding: 0 5px 0 0;
                        }
                    }
                }
            }
            .event-archive-icon {
                font-size: 0.7rem;
                margin-left: 10px;
                margin-top: 2px;
            }
        }
    }
`;

export const MessageText = styled.p`
    font-size: 0.8rem;
    padding: 2px 5px;
`;

export const EventListWrapper = styled.div``;

export const LastUpdated = styled.div`
    font-size: 0.75rem;
    font-weight: 500;
    position: absolute;
    bottom: 10px;
    right: 10px;
`;
